import UniversityPrograms from "../components/HomePage/UniversityPrograms/UniversityPrograms";

const ProgramsPage = () => {
  return (
    <div className="programs-page padding-top">
      <UniversityPrograms />
    </div>
  );
};

export default ProgramsPage;
